export const NORMAL_LIFECYCLE_STATUS = "normal";
export const TRASH_LIFECYCLE_STATUS = "trash";
export const ARCHIVE_LIFECYCLE_STATUS = "archive";

const _disabledStateCache = new Map();
const _devOverrideCache = new Map();
let _lifecycleOverrideLogged = false;

function isDeveloperLifecycleOverrideActive() {
	try {
		const overrides = JSON.parse(
			window?.localStorage?.getItem("developerOverrides") || "{}"
		);
		if (overrides.ignoreLifecycleStatus === "ENABLED") {
			if (!_lifecycleOverrideLogged) {
				console.warn(
					"[DEV] lifecycleStatus disabled state checks are overridden"
				);
				_lifecycleOverrideLogged = true;
			}
			return true;
		}
		return false;
	} catch {
		return false;
	}
}

const withDevOverride = (key, result) => {
	if (!isDeveloperLifecycleOverrideActive() || !result.disabled)
		return result;
	if (_devOverrideCache.has(key)) return _devOverrideCache.get(key);
	const overridden = { ...result, disabled: false };
	_devOverrideCache.set(key, overridden);
	return overridden;
};

// Priority: matter → folder → document/email/note
export function getDisabledStateFromLifecycleStatuses({
	matterLifecycleStatus,
	folderLifecycleStatus,
	documentLifecycleStatus,
	emailLifecycleStatus,
	matterNoteLifecycleStatus,
}) {
	const key = `${matterLifecycleStatus}|${folderLifecycleStatus}|${documentLifecycleStatus}|${emailLifecycleStatus}|${matterNoteLifecycleStatus}`;
	if (_disabledStateCache.has(key))
		return withDevOverride(key, _disabledStateCache.get(key));

	const checks = [
		{ status: matterLifecycleStatus, label: "Matter" },
		{ status: folderLifecycleStatus, label: "Folder" },
		{ status: documentLifecycleStatus, label: "Document" },
		{ status: emailLifecycleStatus, label: "Email" },
		{ status: matterNoteLifecycleStatus, label: "Matter Note" },
	];
	for (const { status, label } of checks) {
		if (status === TRASH_LIFECYCLE_STATUS) {
			const result = {
				disabled: true,
				disabledText: `Not Allowed for a ${label} in the Trash Bin.`,
				IN_TRASH: true,
				itemType: label,
				itemLocation: "Trash Bin",
			};
			_disabledStateCache.set(key, result);
			return withDevOverride(key, result);
		}
		if (status === ARCHIVE_LIFECYCLE_STATUS) {
			const result = {
				disabled: true,
				disabledText: `Not Allowed for a ${label} in the Archive.`,
				IN_ARCHIVE: true,
				itemType: label,
				itemLocation: "Archive",
			};
			_disabledStateCache.set(key, result);
			return withDevOverride(key, result);
		}
	}
	const result = { disabled: false };
	_disabledStateCache.set(key, result);
	return result;
}

export function getClientLifecycleStatusObject(clientLifecycleStatus) {
	const key = `client|${clientLifecycleStatus}`;
	if (_disabledStateCache.has(key))
		return withDevOverride(key, _disabledStateCache.get(key));
	let result;
	if (clientLifecycleStatus === TRASH_LIFECYCLE_STATUS) {
		result = {
			disabled: true,
			disabledText: "Not Allowed for a Client in the Trash Bin.",
			IN_TRASH: true,
			itemType: "Client",
			itemLocation: "Trash Bin",
		};
	} else {
		result = { disabled: false };
	}
	_disabledStateCache.set(key, result);
	return withDevOverride(key, result);
}
